<template>
  <div class="products-home">
    <section class="home-proudcts section-pad">
      <div class="section-heading">
        <h3 class="text-center orange-color">
          Featured Products
          <span class="section-title-divider">
            <img src="/img/icons/divider.png" alt="divider" class="img-fluid" />
          </span>
        </h3>
      </div>
      <div class="section-content">
        <el-row type="flex" justify="center">
          <el-col :xs="22" :lg="20" :md="20" :sm="22" :xl="20">
            <div shadow="never">
              <div v-if="getFeatured">
                <swiper :options="swiperOption" ref="swiperTop">
                  <swiper-slide
                    v-for="product in getFeatured"
                    :key="product.id"
                    class="each-product"
                  >
                    <router-link :to="{name: 'product-details', params: { slug: product.slug}}">
                      <div class="product-image">
                        <img :src="product.images[0].image" :alt="product.name" class="image" />
                      </div>
                      <div class="product-description">
                        <h3>{{product.name}}</h3>
                      </div>
                    </router-link>
                  </swiper-slide>
                </swiper>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </section>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      title: "details",
      loading: false,
      swiperOption: {
        initialSlide: 0,
        spaceBetween: 40,
        speed: 900,
        autoplay: {
          delay: 2000
        },
        breakpoints: {
          1280: {
            slidesPerView: 3,
            spaceBetween: 30
          },
          1068: {
            slidesPerView: 2,
            spaceBetween: 30
          },
          1024: {
            slidesPerView: 2,
            spaceBetween: 20
          },
          960: {
            slidesPerView: 2,
            spaceBetween: 20
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 30
          },
          640: {
            slidesPerView: 1,
            spaceBetween: 20
          },
          320: {
            slidesPerView: 1,
            spaceBetween: 10
          }
        },
        loop: true,
        disableOnInteraction: false,
        centeredSlides: false,
        slidesPerView: "4",
        slideToClickedSlide: false
      }
    };
  },
  computed: {
    ...mapGetters("products", ["getFeatured"])
  },
  products() {
    return this.getFeatured;
  },
  mounted() {
    this.fetchFeatured();
  },
  methods: {
    async fetchFeatured() {
      await this.$store.dispatch("products/featuredProducts");
      this.loading = false;
    }
  }
};
</script>

<style scoped lang="scss">
.home-proudcts {
  .each-product {
    padding: 1.875em 0 1.25em 0;
    border-radius: 0.625em;
    & > a {
      display: block;
    }
    .product-image {
      img {
        height: 300px;
        width: 300px;
        /*border-radius: 100%;*/
        display: table;
        margin: 0 auto;
      }
    }
    @media (max-width: 768px) {
      padding: 0em;
      & .product-image {
        border: 1px solid #f7f7f7;
        padding: 10px;
      }
    }

    .product-details {
      padding-left: 2.188em;
      padding-top: 2.5em;

      .price {
        color: #11233f;
        font-weight: 600;
        font-size: 1.3em;
        margin-bottom: 0px;
      }

      .product-name {
        margin-top: 0.313em;
      }
    }
  }
  .product-description {
    margin-top: 20px;
    text-align: center;
    padding: 0 10px;
    h3 {
      font-size: 0.9em;
      line-height: 25px;
    }
  }
}
</style>
